<template>
  <div class="pa-4">
    <!--            edit-mode-->
    <custom-popup
      v-model="editModal"
      :cons="{ title: isEdit ? 'ویرایش چت' : 'ایجاد چت جدید' }"
      hide-confirm
      max-width="940"
      reloadable
      @reload="reloadAutoChat"
    >
      <v-card flat>
        <v-tabs v-model="tabs" grow>
          <v-tab>{{ isEdit ? "ویرایش" : "افزودن" }}</v-tab>
          <v-tab>متن پیشفرض</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card-text>
              <v-text-field
                v-for="(item, i) in firstKeyword"
                :key="i"
                v-model="item.text"
                :rules="[rules.keyword]"
                append-icon="mdi-pencil"
                class="rounded-lg"
                clearable
                counter="1024"
                dense
                label="کلیدواژه"
                multiple
                outlined
              >
                <template v-slot:append-outer>
                  <v-btn
                    v-if="firstKeyword.length <= 100"
                    class="mt-n1 rounded-lg"
                    color="success"
                    fab
                    outlined
                    x-small
                    @click="firstKeyword.push({ text: '' })"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="!!firstKeyword?.length"
                    class="mt-n1 rounded-lg ms-2"
                    color="red"
                    fab
                    outlined
                    x-small
                    @click="firstKeyword.splice(i, 1)"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <v-textarea
                v-model="firstMessage"
                :rules="[rules.keyword]"
                append-icon="mdi-pencil"
                class="rounded-lg"
                clearable
                counter="1000"
                dense
                label="پیام"
                outlined
              />

              <v-checkbox
                v-model="firstSendToPrev"
                dense
                label="پیام به چت‌های قبلی نیز ارسال شود"
              />
            </v-card-text>

            <v-card-actions class="justify-end">
              <v-btn
                :disabled="!canSubmit"
                :loading="loading"
                class="btn-accept ma-0 rounded-lg"
                depressed
                @click="isEdit ? updateChat() : createChat()"
              >
                <v-icon left>
                  {{ !isEdit ? "mdi-plus" : "mdi-pencil" }}
                </v-icon>
                {{ isEdit ? "ویرایش پیام " : "ثبت پیام" }}
              </v-btn>
            </v-card-actions>
          </v-tab-item>

          <v-tab-item>
            <v-card-text>
              <div v-if="ErrorMessage && ErrorMessage?.length > 0">
                <p class="mt-5 font-weight-bold text-dark">
                  دلایل رد شدن چت شما:
                </p>

                <p
                  v-for="(line, lineNumber) in ErrorMessage.split('\n')"
                  :key="lineNumber"
                  class="pr-5 mr-5 text-danger font-weight-bold"
                >
                  {{ lineNumber + 1 }} - {{ line }}
                </p>
              </div>

              <v-text-field
                v-model="keyWord"
                dense
                disabled
                hint="چنانچه مشتری سوال یا پرسشی به جز کلیدواژه های ثبت شده توسط شما بپرسد، این متن برای ایشان ارسال خواهد شد. 'لازم است بدانید این متن فقط یکبار برای مشتری ارسال میشود، حتی اگر بارها پیام بفرستد.'"
                label="کلیدواژه"
                outlined
                persistent-hint
                readonly
              />

              <v-textarea
                v-model="message"
                dense
                label="پیام"
                outlined
                prepend-inner-icon="fa fa-pencil-alt"
              />

              <v-checkbox
                v-model="firstSendToPrev"
                dense
                label="پیام به چت‌های قبلی نیز ارسال شود"
              />
            </v-card-text>

            <v-card-actions class="justify-end" style="gap: 8px">
              <v-btn
                v-if="!newChatMessage"
                v-status="'chat_update'"
                class="btn-update ma-0 px-4"
                @click="updateChat"
              >
                <span class="fa fa-save" style="font-size: 1.3rem"></span>
                به روز رسانی
              </v-btn>

              <v-btn
                v-if="newChatMessage"
                v-status="'chat_store'"
                :loading="loading"
                class="submit-btn ma-0 px-4"
                @click="createChat"
              >
                <v-icon left>mdi-plus</v-icon>
                ثبت پیام
              </v-btn>
            </v-card-actions>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </custom-popup>
    <!--            edit-mode-->

    <v-card :loading="loading" flat>
      <v-card-title>
        <v-btn class="btn-add-with-text ma-0" @click="newChats">
          <v-icon left>mdi-plus</v-icon>
          ایجاد چت
        </v-btn>
      </v-card-title>

      <template v-status="'chat_conversation'">
        <vue-table :data="data" :headers="headers" @change="onPagination">
          <template v-slot:filters="{ props, perPage }">
            <v-row no-gutters>
              <v-col class="pa-2" cols="12" lg="1" md="2">
                <v-select
                  v-model="props.length"
                  :items="perPage"
                  class="rounded-lg"
                  dense
                  hide-details
                  label="تعداد"
                  outlined
                />
              </v-col>
              <v-col class="pa-2" cols="12" lg="4" md="6">
                <v-text-field
                  v-model="props.search"
                  append-icon="mdi-magnify"
                  class="rounded-lg"
                  clearable
                  dense
                  hide-details
                  label="جستجو"
                  outlined
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:index="{ item }">
            {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
          </template>

          <template v-slot:keyword="{ item }">
            <span
              :class="item.keyword === 'پیشفرض' ? `badge badge-success` : ''"
            >
              {{ item.keyword.replace(/,{2}/g, " - ") }}
            </span>
          </template>

          <template v-slot:status="{ item }">
            <span :class="`badge badge-${statusText(item.status).color}`">
              {{ statusText(item.status).text }}
            </span>
          </template>

          <template v-slot:manage="{ item }">
            <manage-button :data="item" :meta="metaButtons" />
          </template>
        </vue-table>
      </template>
    </v-card>
  </div>
</template>

<script>
import manageButton from "@/view/pages/button";
import { dataTableProps } from "@/main";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import { debounce } from "@/custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "autoChats",

  components: {
    FiltersTable,
    ButtonTempl,
    TitleRibbon,
    CreateDefault,
    manageButton,
    dataTableProps,
    createTarefe,
  },

  props: {
    UserID: {
      type: Number,
      default: () => 0,
    },
    newChat: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      cacheMessage: "",
      localNewChat: this.newChat,
      isEdit: false,
      data: {},
      keyWord: "پیشفرض",
      firstKeyword: [{ text: null }],
      firstMessage: null,
      firstSendToPrev: true,
      message: "",
      editModal: false,
      loading: false,
      result: [],
      ErrorMessage: [],
      chatID: "",
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      url: `${url}/chats`,
      dataId: "",
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center" },
        { value: "id", text: "شناسه", sortable: false, align: "center" },
        {
          value: "keyword",
          text: "کلیدواژه",
          sortable: false,
          align: "center",
        },
        { value: "status", text: "وضعیت", sortable: false, align: "center" },
        { value: "manage", text: "مدیریت", sortable: false, align: "center" },
      ],

      metaButtons: {
        permission_prefix: "notification_",
        buttons: [
          {
            name: "edit",
            label: "ویرایش",
            icon: "pencil-alt",
            class: "btn-outline-warning",
            action: this.actions,
            status: "chat_update",
          },
          {
            name: "delete",
            label: "حذف",
            icon: "trash-alt",
            class: "btn-outline-danger",
            action: this.actions,
          },
        ],
      },
      tabs: 0,
      rules: {
        keyword: (v) =>
          v === null ||
          (!!v && v?.length <= 1024) ||
          "حداقل ۱ و حداکثر ۱۰۲۴ کاراکتر",
        message: (v) =>
          v === null ||
          (!!v && v?.length >= 10 && v?.length <= 1000) ||
          "حداقل ۱۰ و حداکثر ۱۰۰۰ کاراکتر",
      },
      // columns: [
      //   {
      //     label: '<input type="checkbox" id="selectAll">',
      //     isCheckBox: true,
      //     transform: (val) => {
      //       return `<input type="checkbox"  data-id="${val.data.phone}">`
      //     },
      //     orderable: false,
      //   },
      //   {
      //     label: 'ردیف',
      //     transform: (val) => {
      //       let row = this.data.current_page - 1;
      //       row = row * this.data.per_page;
      //       return row + val.row + 1;
      //     },
      //     orderable: true,
      //   },
      //   {
      //     label: 'شناسه',
      //     name: 'id',
      //     orderable: true,
      //     searchable: true,
      //   },
      //   {
      //     label: 'کلیدواژه',
      //     name: 'keyword',
      //     orderable: true,
      //     searchable: true,
      //   },
      //   {
      //     label: 'وضعیت',
      //     name: 'status',
      //     primary: true,
      //     transform: (val) => {
      //       const error = {
      //         verify: {text: 'تایید شده', color: 'success'},
      //         waiting: {text: 'در انتظار تایید', color: 'warning'},
      //         unverified: {text: 'رد شده', color: 'danger'},
      //       };
      //       return `<span class="badge badge-${error[val.data.status].color}">${error[val.data.status].text}</span>`
      //     },
      //     orderable: true,
      //     searchable: true,
      //   },
      //   {
      //     label: 'مدیریت',
      //     name: 'action',
      //     component: button,
      //     handler: this.actions,
      //     event: "actions",
      //     meta: {
      //       permission_prefix: 'notification_',
      //       buttons: [
      //         {
      //           name: 'edit',
      //           label: 'ویرایش',
      //           icon: 'pencil-alt',
      //           class: 'btn-outline-warning',
      //           action: this.actions,
      //           status: 'chat_update'
      //
      //         },
      //         {
      //           name: 'delete',
      //           label: 'حذف',
      //           icon: 'trash-alt',
      //           class: 'btn-outline-danger',
      //           action: this.actions,
      //         },
      //       ]
      //     }
      //   }
      // ],
      searchBox: {
        search: "",
        length: 10,
      },
    };
  },

  mounted() {
    this.tableProps = {
      search: "",
      length: 10,
      column: "id",
      dir: "desc",
      page: 1,
    };
    this.getDataForTable(this.url);
    $(document).on("click", "#selectAll", (element) => {
      if ($(element.target).is(":checked")) {
        $('input[type="checkbox"]').prop("checked", true);

        const selected = $('input[type="checkbox"]')
          .map(function () {
            return $(this).data("id");
          })
          .get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop("checked", false);
        this.selectedNumber = [];
      }
    });
    this.$forceUpdate();
  },

  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          this.getDataForTable(this.url);
          return true;
        case "sm":
          this.getDataForTable(this.url);
          return true;
        case "md":
          this.getDataForTable(this.url);
          return false;
        case "lg":
          this.getDataForTable(this.url);
          return false;
        case "xl":
          this.getDataForTable(this.url);
          return false;
      }
    },
    newChatMessage: {
      get() {
        const foundItem = this.data?.data?.find((x) => x.keyword === "پیشفرض");
        this.cacheMessage = foundItem ? foundItem.message : null;
        return this.cacheMessage !== null ? false : true;
      },
      set(value) {
        this.cacheMessage = value ? "" : this.cacheMessage;
      },
    },
    canSubmit() {
      return (
        this.firstKeyword.every((item) => item.text?.length <= 1024) &&
        this.firstMessage?.length <= 1000
      );
    },
  },

  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox?.length;
      },
      deep: true,
    },
  },
  methods: {
    statusText(status) {
      const error = {
        verify: { text: "تایید شده", color: "success" },
        waiting: { text: "در انتظار تایید", color: "warning" },
        unverified: { text: "رد شده", color: "danger" },
      };

      return error[status];
    },
    getDataForTable(query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: this.url,
        fn: this.getDataForTable,
        type: "GET",
        data: query,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: function (data) {
          vm.data = data;
          vm.loading = false;
          const foundItem = data.data.find((x) => x.keyword === "پیشفرض");
          vm.message = foundItem ? foundItem.message : null;
          //  vm.newChatMessage = vm.cacheMessage !== null ? false : true;
        },
      });
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getDataForTable(props);
    },
    newChats() {
      this.tabs = 0;
      this.isEdit = false;
      this.reloadAutoChat();
      this.ErrorMessage = [];
      this.editModal = true;
      this.localNewChat = true;
    },
    actions(data, type) {
      this.tabs = 0;
      if (type === "edit") {
        this.isEdit = true;
        this.chatID = data.id;
        this.editModal = true;
        this.localNewChat = false;
        console.log(this.isEdit, "this.isEdit");
        this.firstKeyword = data.keyword.split(",,").map((item) => ({
          text: item,
        }));
        this.ErrorMessage = data.error;
        // this.message = data.message;
        // this.newChatMessage = this.message?.length > 0 ? false : true;
        console.log(this.newChatMessage, "3", this.chatID);
        this.firstMessage = data.message;
      } else if (type === "delete") {
        this.$modal
          .yesNo("تایید حذف", "آیا از حذف این دسته اطمینان دارید؟", "neg", "")
          .then((value) => {
            if (value === true) {
              $.ajax({
                url: `${url}/chats/${data.id}`,
                fn: this.actions,
                paramas: [data, type],
                type: "DELETE",
                headers: {
                  ACCEPT: "application/json",
                  Authorization: Token,
                },
                msg: true,
                success: (data) => {
                  this.getDataForTable(this.url, this.tableProps);
                },
              });
            }
          });
      }
    },
    updateChat() {
      let data =
        this.tabs === 0
          ? {
              keyword: this.firstKeyword.map((item) => item.text).join(",,"),
              message: this.firstMessage,
              old_pm: !!this.firstSendToPrev ? 1 : 0,
            }
          : {
              keyword: this.keyWord || "پیشفرض",
              message: this.message,
              old_pm: !!this.firstSendToPrev ? 1 : 0,
            };
      if (this.tabs === 0) {
        console.log(this.chatID, "-22");
        $.ajax({
          url: `${url}/chats/${this.chatID}`,
          type: "Put",
          fn: this.updateChat,
          data: data,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
          msg: true,
          success: (data) => {
            this.editModal = false;
            this.localNewChat = true;
            this.newChatMessage =
              this.message === null || this.message === "" ? true : false;
            console.log(this.newChatMessage, "2");

            // this.message = "";
            this.onPagination();
          },
        });
      } else {
        const foundItem = this.data.data.find((x) => x.keyword === "پیشفرض");
        $.ajax({
          url: `${url}/chats/${foundItem.id}`,
          type: "Put",
          fn: this.updateChat,
          data: data,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
          msg: true,
          success: (data) => {
            this.editModal = false;
            this.localnewChat = true;
            this.newChatMessage =
              this.message === null || this.message === "" ? true : false;
            console.log(this.newChatMessage, "2");

            // this.message = "";
            this.onPagination();
          },
        });
      }
    },
    createChat() {
      this.isEdit = false;
      this.loading = true;

      let data =
        this.tabs === 0
          ? {
              keyword: this.firstKeyword.map((item) => item.text).join(",,"),
              message: this.firstMessage,
              old_pm: !!this.firstSendToPrev ? 1 : 0,
            }
          : {
              keyword: this.keyWord || "پیشفرض",
              message: this.message,
              old_pm: !!this.firstSendToPrev ? 1 : 0,
            };

      if (!data.keyword?.trim())
        return this.$toast.error("کلیدواژه الزامی است!");
      if (this.tabs === 0) {
        $.ajax({
          url: `${url}/chats`,
          type: "POST",
          fn: this.createChat,
          data: data,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
          msg: true,
          success: (data) => {
            this.loading = false;
            this.editModal = false;
            this.onPagination();
            this.reloadAutoChat();
          },
        });
      }
      if (this.tabs === 1 && this.newChatMessage) {
        $.ajax({
          url: `${url}/chats`,
          type: "Post",
          fn: this.createChat,
          data: data,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
          msg: true,
          success: (data) => {
            this.loading = false;
            this.editModal = false;
            this.onPagination();
            this.reloadAutoChat();
          },
        });
      } else if (!this.newChatMessage && this.tabs === 1) {
        const foundItem = this.data.data.find((x) => x.keyword === "پیشفرض");
        $.ajax({
          url: `${url}/chats/${foundItem.id}`,
          type: "Post",
          fn: this.updateChat,
          data: data,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
          msg: true,
          success: (data) => {
            this.editModal = false;
            this.newChat = true;
            this.newChatMessage =
              this.message === null || this.message === "" ? true : false;
            console.log(this.newChatMessage, "2");

            // this.message = "";
            this.onPagination();
          },
        });
      }
    },
    reloadAutoChat() {
      this.keyWord = "پیشفرض";
      // this.message = "";
      this.firstKeyword = [{ text: null }];
      this.firstMessage = null;
      this.firstSendToPrev = true;
      this.tabs = 0;
    },
  },
};
</script>

<style scoped></style>
